<template>
    <el-input type="text"  size="mini"  :disabled="isdisabled" v-model="inputval" @input="getVal"></el-input>
</template>

<script>
/*
 @name:elemnet ui数字控件  ps：只能输入数字 小数点
 @createdby:常九福
 @modifier:王越
 @include
    @example template: <lnk-input-number isdisabled="true"  v-model="inputval"></lnk-input-number>


    @props:

    isdisabled:String,//是否禁用输入框
    * */
export default {
    name: 'lnk-input-number',
    data: function(){
        return {inputval: ''};
    },
    props: {
        inputvalue: '',
        isdisabled: {
            type: Boolean,
            default: false
        },
        lnktype: {
            type: String,
            default: 'number'
        }
    },
    model: {prop: 'inputvalue'},
    watch: {
        inputvalue(val){
            this.inputval = val;
        }

    },
    methods: {
        getVal: function(val){
            var value = '';
            if (val != '' && val != undefined) {
                var str = val.toString();
                if(this.lnktype == 'number'){
                    value = str.replace(/[^\d.]/ig, '');
                }else if(this.lnktype == 'codenumber'){
                    value = str.replace(/[\W]/g, '');
                }else if(this.lnktype == 'intnumber'){
                    value = str.replace(/\D/g, '');
                }
                this.$nextTick(() => {
                    this.inputval = value;
                    if(value != '' && value != undefined){
                        this.$emit('input', value - 0);
                    }else{
                        this.$emit('input', value);
                    }
                });
            }else{
                this.$emit('input', value);
            }
        }
    },
    mounted: function(){
        if (this.inputvalue != undefined) {
            this.inputval = this.inputvalue;
        }else{
            this.inputval = '';
        }
    }
};
</script>

<style scoped>

</style>
